// Converts a failing write (e.g. QuotaExceededError) to false instead of throwing
export const setLocalStorageItemSafely = (
  key: string,
  value: unknown
): boolean => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
};
